// app/ClientProviders.tsx
"use client"

import { ReactNode, Suspense } from "react"
import { CategoriesProvider } from "@/contexts/categories-context"
import { SearchProvider } from "@/contexts/search-context"

export function ClientProviders({ children }: { children: ReactNode }) {
  return (
    <Suspense fallback={<div>Loading…</div>}>
      <CategoriesProvider>
        <SearchProvider>{children}</SearchProvider>
      </CategoriesProvider>
    </Suspense>
  )
}
